import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { AutomationItem } from 'src/components/AutomationTrading/AutomationItem/AutomationItem';
import { AppState, useAppStateContext } from 'src/AppState/AppState';
import { Resource } from 'src_common/common/mobx-utils/Resource';
import { AutomationWrapper } from 'src/components/AutomationTrading/AutomationItem/AutomationItem.style';
import { ApiGetAutomationsResponse200Type } from 'src/api_openapi/v2/automations/apiGetAutomations';
import { AutomationPopupState } from 'src/components/AutomationTrading/AutomationPopup/AutomationPopup.state';
import { AutomationPopup } from 'src/components/AutomationTrading/AutomationPopup/AutomationPopup';
import { computed, makeAutoObservable } from 'mobx';

export type AutomationItemType = ApiGetAutomationsResponse200Type['items'][number];
type ActionType = Extract<AutomationItemType['actions'][number], { kind: 'events' }>['events'];
export type AutomationFilter = ActionType['filters'][number];
export type WhereType = Extract<AutomationFilter, { kind: 'where' }>['where'];
export type DateTimeType = Extract<WhereType['value'], { kind: 'datetime' }>['datetime'];
// type InType = Extract<AutomationFilter, { kind: 'in' }>['in']
// type BetweenType = Extract<AutomationFilter, { kind: 'between' }>['between']

export class AutomationTradingState {
    public allAutomations: Resource<ApiGetAutomationsResponse200Type>;
    public constructor(private readonly appState: AppState) {
        this.allAutomations = new Resource(async (): Promise<ApiGetAutomationsResponse200Type> => {
            const resp = await this.appState.sdkStaff.trading.autotrader.getAutotraderAutomations();
            if (resp.status !== 200) {
                console.error(JSON.stringify(resp));
                return { items: [] };
            }
            return resp.body;
        });
        makeAutoObservable(this);
    }

    @computed public get getAutomations(): ApiGetAutomationsResponse200Type {
        const res = this.allAutomations.get();
        if (res.type === 'ready') {
            return res.value;
        }
        return { items: [] };
    }
}

export const AutomationTrading = observer('AutomationTrading', () => {
    const appState = useAppStateContext();
    const [state] = useState(() => new AutomationTradingState(appState));
    const [historyEventsPopupState] = useState(() => new AutomationPopupState());

    const automations = state.getAutomations;
    console.log('automations ', automations);

    // if (automations.type === 'loading') {
    //     return (
    //         <div>
    //             <h2>Loading...</h2>
    //         </div>
    //     );
    // }

    return (
        <AutomationWrapper>
            {automations.items.map((item, index) => {
                return (
                    <AutomationItem
                        key={`${index}-${item.id}`}
                        automationItem={item}
                        automationState={state}
                        popupState={historyEventsPopupState}
                    />
                );
            })}
            <AutomationPopup popupState={historyEventsPopupState} />
        </AutomationWrapper>
    );
});
